import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";

type SortableProperties = "name" | "address" | "quality" | "aggregationUnit" | "currency";

interface Props {
  property: SortableProperties;
  activeSort: { property: SortableProperties; direction: "asc" | "desc" };
  handleSort: (property: SortableProperties) => void;
  children: React.ReactNode;
  width?: string;
  hideSortIcon?: boolean;
  colSpan?: number;
  onClick?: (e: React.MouseEvent<unknown>) => void;
}

export function TableHeadSortLabel({
  property,
  activeSort,
  handleSort,
  children,
  width,
  hideSortIcon,
  colSpan,
  onClick
}: Props) {
  const handleClick = (e: React.MouseEvent<unknown>) => {
    if (onClick) {
      onClick(e);
    }
    if (handleSort && !hideSortIcon) {
      handleSort(property);
    }
  };

  return (
    <TableCell sx={{ width, fontSize: 12 }} colSpan={colSpan}>
      <TableSortLabel
        active={activeSort.property === property}
        onClick={handleClick}
        direction={
          activeSort.property === property ? activeSort.direction : "asc"
        }
        hideSortIcon={hideSortIcon}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  );
}
